import React, { FC } from 'react';
import { Section } from 'omni-package-react-core';
import { useTranslation } from 'react-i18next';
import { PersonalInformation } from '../../../../interfaces/PersonalInformation';
import Phone from './Phone';

export interface PhonesProps {
  personalInfo: PersonalInformation;
}
const Phones: FC<PhonesProps> = ({ personalInfo }) => {
  const { t } = useTranslation('PersonalInformationsTile');

  if (!personalInfo || !personalInfo.phones) return null;

  if (personalInfo.phones.behaviours.showSection === false) return null;
  if (personalInfo.phones.cell === '' &&
    personalInfo.phones.fax === '' &&
    personalInfo.phones.home === '' &&
    personalInfo.phones.work === '') return null;

  return (
    <Section name={t('phones.title')}>
      <Phone personalInfo={personalInfo}></Phone>
    </Section>
  );
};
export default Phones;
